import { of, ReplaySubject } from 'rxjs';
import { distinctUntilChanged, map, tap } from 'rxjs/operators';

import { computed, Injectable, signal } from '@angular/core';

import { NavBarInstance } from '@home/shared/modules/nav-bar/nav-bar.models';

import { crud } from '@shared/operators/crud.operator';
import { isShallowEqual } from '@shared/utilities/object.utilities';
import { clamp } from '@shared/utilities/number.utilities';

@Injectable({
  providedIn: 'root',
})
export class NavBarService {
  private addLayer$ = new ReplaySubject<NavBarInstance>(1);

  private updateLayer$ = new ReplaySubject<NavBarInstance>(1);

  private removeLayer$ = new ReplaySubject<NavBarInstance>(1);

  readonly currentLayer$ = new ReplaySubject<NavBarInstance>(1);

  readonly scrollHideHeight = signal(0);

  readonly scrollBarHeight = computed(() => clamp(49 - this.scrollHideHeight(), 0, 49));

  constructor() {
    crud(of([]), this.addLayer$, this.removeLayer$, this.updateLayer$, 'content')
      .pipe(
        map((layers) => layers[layers.length - 1]),
        distinctUntilChanged(isShallowEqual),
        tap((layer) => this.currentLayer$.next({ ...layer })),
      )
      .subscribe();
  }

  updateLayer(layer: NavBarInstance): void {
    this.updateLayer$.next(layer);
  }

  addLayer(layer: NavBarInstance): void {
    this.addLayer$.next(layer);
  }

  removeLayer(layer: NavBarInstance): void {
    this.removeLayer$.next(layer);
  }
}
